"use client";

import { useEffect, useRef } from "react";
import styles from "./home-product-video.module.css";

const videoStructuredData = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  contentUrl: "https://boardblend.com/api/product-video",
  description:
    "See how teams use Boardblend to explore ideas with their own AI agents and shape them into one shared visual plan.",
  duration: "PT34S",
  name: "How Boardblend brings team ideas together",
  thumbnailUrl: "https://boardblend.com/video/boardblend-product-poster.png",
  uploadDate: "2026-07-26",
};

export function HomeProductVideo() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio < 0.5) return;

        void video.play();
        observer.disconnect();
      },
      { threshold: 0.5 },
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={styles.section}
      id="product"
      aria-labelledby="product-video-heading"
    >
      <div className={styles.heading}>
        <h2 id="product-video-heading">
          Think in parallel. Decide together.
        </h2>
      </div>

      <video
        ref={videoRef}
        aria-label="Boardblend product demonstration"
        controls
        controlsList="nodownload noplaybackrate"
        disablePictureInPicture
        muted
        playsInline
        poster="/video/boardblend-product-poster.png"
        preload="metadata"
      >
        <source src="/api/product-video" type="video/mp4" />
      </video>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(videoStructuredData).replace(/</g, "\\u003c"),
        }}
      />
    </section>
  );
}
